import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
interface AchievementBadgeProps {
  icon: string;
  title: string;
  description: string;
  unlocked: boolean;
}
export function AchievementBadge({
  icon,
  title,
  description,
  unlocked
}: AchievementBadgeProps) {
  return <motion.div whileHover={{
    scale: 1.05
  }} className={`
        flex flex-col items-center text-center p-4 rounded-2xl border-2
        ${unlocked ? 'bg-white dark:bg-[#252936] border-gray-100 dark:border-gray-800' : 'bg-gray-50 dark:bg-gray-900 border-transparent opacity-60'}
      `} data-id="element-51">
      <div className="text-4xl mb-3 relative" data-id="element-52">
        {icon}
        {!unlocked && <div className="absolute inset-0 flex items-center justify-center bg-black/10 rounded-full backdrop-blur-[1px]" data-id="element-53">
            <Lock className="w-6 h-6 text-gray-500" data-id="element-54" />
          </div>}
      </div>
      <h3 className="font-fredoka font-bold text-sm text-game-dark dark:text-white mb-1" data-id="element-55">
        {title}
      </h3>
      <p className="text-xs text-gray-500 dark:text-gray-400 font-quicksand leading-tight" data-id="element-56">
        {description}
      </p>
    </motion.div>;
}